import React, { CSSProperties } from 'react';
import CardsResponsiveListing from 'dashboard/components/cards-responsive-listing';
import OfferingCard from 'offerings/components/offering-card';
import { Course } from 'redux/schemas/models/course';

type Props = {
  offerings: Course[],
  className?: string,
  collapserClassName?: string,
  spaceBetweenCards?: number,
  offeringCardStyle?: CSSProperties,
  openInNewTab?: boolean,
  dataQa?: string,
  dataQaId?: (offering: Course, index: number) => string,
};

const OfferingCardsResponsiveListing = (props: Props) => (
  <CardsResponsiveListing
    items={props.offerings}
    className={props.className}
    collapserClassName={props.collapserClassName}
    keyExtractor={(course: Course) => course.catalogId}
    spaceBetweenCards={props.spaceBetweenCards}
    renderItem={({ item, props: cardProps }, index) => (
      <OfferingCard
        offering={item}
        ref={cardProps.ref}
        style={{ ...cardProps.style, ...props.offeringCardStyle }}
        openInNewTab={props.openInNewTab}
        dataQa={props.dataQa}
        dataQaId={props.dataQaId?.(item, index)}
      />
    )}
  />
);

export default OfferingCardsResponsiveListing;
